export const rxAmount = /^\d+(\.\d{1,2})?$/;
// eslint-disable-next-line max-len
export const rxEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validationSchema = (values) => {
  const errors = {};
  if (!values.portfolio) {
    errors.portfolio = 'Select a portfolio';
  }
  if (values.portfolioYear === null) {
    errors.portfolio = 'Select a portfolio';
  }
  if (!values.cash) {
    errors.cash = 'Write cash amount';
  }
  if (values.cash && !rxAmount.test(values.cash)) {
    errors.cash = 'Invalid cash amount';
  }
  if (!values.goods) {
    errors.goods = 'Write goods amount';
  }
  if (values.goods && !rxAmount.test(values.goods)) {
    errors.goods = 'Invalid goods amount';
  }
  if (!values.volunteerism) {
    errors.volunteerism = 'Write volunteerism amount';
  }
  if (values.volunteerism && !rxAmount.test(values.volunteerism)) {
    errors.volunteerism = 'Invalid volunteerism amount';
  }
  if (!values.services) {
    errors.services = 'Write services amount';
  }
  if (values.services && !rxAmount.test(values.services)) {
    errors.services = 'Invalid services amount';
  }
  return errors;
};